'use es6';

import { Record, List } from 'immutable';
export default Record({
  assetId: null,
  classId: null,
  completed: null,
  congratulationsText: null,
  description: null,
  displayOrder: null,
  exerciseLocation: null,
  graded: false,
  hasError: false,
  id: null,
  isRequesting: null,
  language: null,
  manuallyApproved: false,
  name: null,
  internalName: null,
  performedInApp: false,
  performedInAppSkipMessage: null,
  progressType: null,
  recentError: null,
  requiredAccess: new List(),
  requiredProducts: new List(),
  started: false,
  subject: null,
  submitted: false,
  trackerNotRequired: false,
  type: '',
  fileSubmissionRequired: null
}, 'PracticalExercise');